/** État de navigation après changement de mot de passe initial. */
export const FIRST_LOGIN_NAV_STATE = { fromFirstLogin: true, requireProfileCompletion: true };

export function hasLinkedMemberProfile(user) {
  return Boolean(String(user?.member_id || user?.person_id || '').trim());
}

/**
 * Destination après première connexion (mot de passe changé).
 * Membres liés → compléter la fiche ; sinon tableau de bord (ou portail).
 */
export function getPostFirstLoginDestination(user, { fallback = '/dashboard' } = {}) {
  if (hasLinkedMemberProfile(user)) {
    return '/profile/edit';
  }
  return fallback;
}

export function buildFirstLoginNavigateState(user, { fallback = '/dashboard' } = {}) {
  const destination = getPostFirstLoginDestination(user, { fallback });
  if (destination === '/profile/edit') {
    return { ...FIRST_LOGIN_NAV_STATE, returnFallback: fallback };
  }
  return undefined;
}

export function buildProfileCompletionNavigateState({ fallback = '/dashboard' } = {}) {
  return { requireProfileCompletion: true, returnFallback: fallback };
}